import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import LandingPage from './pages/LandingPage';
import ApplicationForm from './pages/ApplicationForm';
import ApplicationSuccess from './pages/ApplicationSuccess';
import { ApplicationProvider } from './context/ApplicationContext';

function App() {
  return (
    <ApplicationProvider>
      <Router>
        <div className="min-h-screen bg-gray-50 w-full max-w-full overflow-x-hidden">
          <AnimatePresence mode="wait">
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/apply" element={<ApplicationForm />} />
              <Route path="/success" element={<ApplicationSuccess />} />
            </Routes>
          </AnimatePresence>
        </div>
      </Router>
    </ApplicationProvider>
  );
}

export default App;